module.exports = __webpack_public_path__ + "static/img/拆迁-2.12911040.png";